/**
 * AdminInstallRpcClient - AtomRpc integration for admin install endpoints
 *
 * Backs the Installs admin UI: list, detail, and create. Requires admin
 * authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminInstallRpcClient extends AtomRpc.Tag<AdminInstallRpcClient>()(
  "AdminInstallRpcClient",
  {
    group: InstallsRpcs,
    protocol: makeRpcClientLayer(InstallsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
